import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Tek tıkla açılır-kapanır bölüm; tercih tarayıcıda hatırlanır (varsayılan kapalı).
export const Fold = ({ id, title, icon, extra, children }) => {
  const key = `fchem_fold_${id}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) === "1");
  const toggle = () => { localStorage.setItem(key, open ? "0" : "1"); setOpen(!open); };
  return (
    <section className="space-y-3" data-testid={`fold-${id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={toggle} className="font-display text-2xl font-bold flex items-center gap-2 hover:text-[#FACC15] transition-colors" aria-expanded={open} data-testid={`fold-toggle-${id}`}>
          {icon}{title}<ChevronDown className={`h-5 w-5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </button>
        {extra}
      </div>
      {open && <div className="space-y-3 fade-in">{children}</div>}
    </section>
  );
};
